import { apiService } from '../services/api';
import type {
  MaterialType,
  MaterialConsumption,
  CreateMaterialConsumption,
  UpdateMaterialConsumption,
  MaterialAllocation,
  CreateMaterialAllocation,
  MaterialWasteReport
} from '../types/material';

// Material Types API
export const materialTypesApi = {
  getAll: async (): Promise<MaterialType[]> => {
    return apiService.getMaterialTypes();
  },

  getById: async (id: number): Promise<MaterialType> => {
    const types = await apiService.getMaterialTypes();
    const type = types.find(t => t.id === id);
    if (!type) throw new Error(`Material type with id ${id} not found`);
    return type;
  },

  getUnits: async (materialTypeId: number) => {
    return apiService.getMaterialUnitsForType(materialTypeId);
  }
};

// Material Consumption API
export const materialConsumptionApi = {
  getByWorkEntry: async (workEntryId: number): Promise<MaterialConsumption[]> => {
    return apiService.getMaterialConsumptions(workEntryId);
  },

  create: async (consumption: CreateMaterialConsumption & { addedByUserId: number }): Promise<MaterialConsumption> => {
    return apiService.createMaterialConsumption({
      workEntryId: consumption.workEntryId,
      materialTypeId: consumption.materialTypeId,
      quantity: consumption.quantity,
      unitId: consumption.unitId,
      addedByUserId: consumption.addedByUserId,
      addedForUserId: consumption.addedForUserId,
      notes: consumption.notes
    });
  },

  update: async (id: number, consumption: UpdateMaterialConsumption): Promise<void> => {
    return apiService.updateMaterialConsumption(id, {
      quantity: consumption.quantity,
      unitId: consumption.unitId,
      notes: consumption.notes
    });
  },

  delete: async (id: number): Promise<void> => {
    return apiService.deleteMaterialConsumption(id);
  }
};

// Material Allocation API
export const materialAllocationApi = {
  getByProject: async (projectId: number): Promise<MaterialAllocation[]> => {
    return apiService.getMaterialAllocations(projectId);
  },

  create: async (allocation: CreateMaterialAllocation): Promise<MaterialAllocation> => {
    return apiService.createMaterialAllocation({
      projectId: allocation.projectId,
      materialTypeId: allocation.materialTypeId,
      allocatedQuantity: allocation.allocatedQuantity,
      unitId: allocation.unitId,
      allocationDate: allocation.allocatedDate
    });
  },

  getWasteReport: async (projectId: number): Promise<MaterialWasteReport[]> => {
    return apiService.getMaterialWasteReport(projectId);
  }
};